export default String.raw`
.products-page__main-container{
    margin: 15px;
    .left{
        display: none;
        width: 100%;
        background: #fff;
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        z-index: 1000;
        overflow-y: auto;
    }
    .right{
        width: 100%;
    }
}

.categories-and-filters-header{
    display: flex;
    justify-content: space-between;
    background-color: #F8F9FA;
    padding: 15px;
    &__title{
        font-size: 18px;
        font-weight: 600;
        line-height: 24px;
    }
    svg{
        width: 24px;
        height: 24px;
        fill: #959595;
        cursor: pointer;
    }
}

.categories{
    border: none;
    &__title{
        padding-bottom: 15px;
        border-bottom: 1px solid #D5D5D5;
    }
}

.filters{
    border: none;
}

.sorting-and-views{
    display: block;
    position: relative;
    &__toggle-filters-menu{
        margin-bottom: 15px;
        margin-right: 15px;
        display: inline-flex;
        padding: 8px 24px;
        float: none;
        svg{
            width: 15px;
            height: 15px;
            fill: $primaryColor;
        }
    }
    &__sorting-list{
        display: inline-block;
        vertical-align: top;
        margin-right: 140px;

        @media screen and (max-width: 410px) {
            margin: 0;
        }
    }
    &__views-list{
        position: absolute;
        top: 0;
        right: 0;
    }
}


.quick-shopping-buttons-container {
    display: block;

    &__buttons {
        justify-content: space-between;
        padding-top: 16px;

        .login-to-see-prices {
            &__icon {
                flex-shrink: 0;
            }
        }

        .primary-action-button {
            margin: 0;
        }
    }
}
`